import { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Button,
  Text,
  Stack,
  Tooltip,
  useToast,
  Spinner,
  Heading,
  IconButton,
  Icon,
} from "@chakra-ui/react";
// import SidePanel from "../../../../components/sidepanelNew/SidePanel";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import SidePanelHeader from "../../../components/sidepanelNew/SidePanelHeader";
// import TabsComponentNew from "../../../../components/tabs/TabsComponentNew";
// import CheckoutForm from "./partials/CheckoutForm";
// import { useCheckout } from "../../../../contexts/CheckoutContext";
// import PaymentSummary from "./partials/PaymentSummary";
import {
  primary,
  secondary,
  white,
  buttonRed,
  buttonRedText,
  primaryAlt,
  textSecondary,
} from "../../../../utils/colors";
import { useStripe } from "@stripe/react-stripe-js";
// import { listTenantDetails } from "../../../../actions/tenantActions";
// import SubscriptionInfo from "./partials/SubscriptionInfo";
import { FaArrowLeftLong, FaCcStripe, FaXmark } from "react-icons/fa6";
import useThemeColors from "../../../../hooks/useThemeColors";
// import BillingInfo from "./partials/BillingInfo";
import { createSubscriptionCheckout } from "../../../../actions/paymentActions";
import BillingInfoNew from "./partials/BillingInfoNew";
// import SubscriptionInfoNew from "./partials/SubscriptionInfoNew";
import SubscriptionSelectedPlanInfo from "./partials/SubscriptionSelectedPlanInfo";

// console.log("process.env", process.env);

const PRICE_IDS = {
  treatmentPlans: {
    free: {
      monthly: "",
      annual: "",
    },
    premium: {
      monthly:
        process.env.REACT_APP_STRIPE_PRICE_ID_TREATMENTPLANS_PREMIUM_MONTHLY,
      annual:
        process.env.REACT_APP_STRIPE_PRICE_ID_TREATMENTPLANS_PREMIUM_ANNUAL,
    },
    enterprise: {
      monthly:
        process.env.REACT_APP_STRIPE_PRICE_ID_TREATMENTPLANS_ENTERPRISE_MONTHLY,
      annual:
        process.env.REACT_APP_STRIPE_PRICE_ID_TREATMENTPLANS_ENTERPRISE_ANNUAL,
    },
  },
};

const CheckoutModalStripe = ({
  slug,
  selectedSubscription,
  setSelectedSubscription,
  setCheckoutPanelOpen,
  setSelectedStripePriceId,
  monthly,
  setMonthly,
  selectedPlan,
  setSelectedPlan,
  currentCurrency,
  setCurrentCurrency,
}) => {
  // GENERAL
  const { t, i18n } = useTranslation();
  const toast = useToast();

  const stripe = useStripe();

  const { backgroundLightMode, newBorderMode, textPrimaryMode } =
    useThemeColors();

  // STATE
  // const [isYearly, setIsYearly] = useState(false);

  const [priceId, setPriceId] = useState([]);

  const [companyName, setCompanyName] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState({
    street: "",
    city: "",
    country: "",
    zip: "",
    display: "",
  });
  const [vatCode, setVatCode] = useState("");

  const [isIndividual, setIsIndividual] = useState(false);

  // ERROR STATES
  const isFullNameValid = fullName && fullName.length > 0;
  const isCompanyNameValid = companyName && companyName.length > 0;
  const isCompanyCodeValid = companyCode && companyCode.length > 0;

  const isStreetValid = address.street && address.street.length > 0;
  const isCityValid = address.city && address.city.length > 0;
  const isCountryValid = address.country && address.country.length > 0;
  const isZipValid = address.zip && address.zip.length > 0;

  // REDUX
  const dispatch = useDispatch();

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const {
    tenant,
    loading: loadingTenant,
    error: errorTenant,
  } = tenantDetailsBySlug;

  const paymentUpdateSubscriptionBillingAndCreateCheckout = useSelector(
    (state) => state.paymentUpdateSubscriptionBillingAndCreateCheckout
  );
  const {
    loading: loadingCheckout,
    error: errorCheckout,
    success: successCheckout,
    checkoutUrl,
  } = paymentUpdateSubscriptionBillingAndCreateCheckout;

  // HANDLERS
  const closeHandler = () => {
    // setSidePanelOpen(false);
    setSelectedStripePriceId(null);
    setSelectedPlan(null);
  };

  const closeModalHandler = () => {
    setCheckoutPanelOpen(false);
    setSelectedStripePriceId(null);
    setSelectedSubscription(null);
  };

  const handleCheckout = () => {
    // if (selectedSubscription.plan === "free") {
    //   toast({
    //     title: "Free plan does not require payment",
    //     description: "You are already using the free plan.",
    //     status: "info",
    //     duration: 5000,
    //     isClosable: true,
    //   });
    //   return;
    // }
    const priceIdToUse = !monthly
      ? PRICE_IDS[selectedSubscription.name]?.[selectedPlan.key]?.annual
      : PRICE_IDS[selectedSubscription.name]?.[selectedPlan.key]?.monthly;

    console.log("priceIdToUse", priceIdToUse);
    console.log("selectedSubscription name", selectedPlan.key);
    console.log("selectedSubscription plan", selectedPlan.key);

    console.log("monthly", monthly);

    if (!priceIdToUse) {
      toast({
        title: "Price ID not configured",
        description: "Contact support or try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    let priceAmount = 0;
    if (monthly) {
      priceAmount = selectedPlan.priceUsdAnnual;
    } else {
      priceAmount = selectedPlan.priceUsdMontly;
    }

    console.log("priceAmount", priceAmount);

    const subscriptionData = {
      slug: slug,
      tenantID: userInfo.tenantID,
      subscriptionName: selectedSubscription.name,
      priceId: priceIdToUse, // ✅ Ensure correct price ID
      isYearly: !monthly, // ✅ Pass isYearly explicitly
      isIndividual,
      companyName,
      companyCode,
      fullName,
      vatCode,
      address,
      plan: selectedPlan.key,
      priceAmountUsd: priceAmount,
    };

    dispatch(createSubscriptionCheckout(slug, subscriptionData));
  };

  // USE EFFECT
  useEffect(() => {
    if (errorCheckout) {
      toast({
        title: t("toasts.checkoutError"),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [errorCheckout]);

  // const { loading, checkoutUrl, error } = useSelector(
  //   (state) => state.paymentSubscription
  // );

  // useEffect(() => {
  //   if (checkoutUrl) {
  //     window.location.href = checkoutUrl; // Redirect to Stripe checkout page
  //   }
  // }, [checkoutUrl]);

  // ERROR

  // LOGS
  // console.log("activeClientSecret:", activeClientSecret);
  // console.log("activeSetupIntentSecret:", activeSetupIntentSecret);
  // console.log("selectedSubscription:", selectedSubscription);

  console.log("selectedSubscription:", selectedSubscription);
  // console.log("monthly:", monthly);
  // console.log("isYearly:", isYearly);
  console.log("selectedPlan:", selectedPlan);
  // console.log("companyName:", companyName);
  // console.log("companyCode:", companyCode);
  // console.log("fullName:", fullName);
  // console.log("address:", address);
  // console.log("vatCode:", vatCode);

  // console.log("errorCheckout:", errorCheckout);

  console.log("tenant:", tenant);

  console.log("PRICE_IDS", PRICE_IDS);

  return (
    <>
      {/* HEADER START */}
      <Flex
        align="center"
        justify="space-between"
        p="2rem 0rem"
        // position="sticky"
        top="0"
        left="0"
        bg={white}
        w="100%"
      >
        <Flex align="center">
          <Flex align="center">
            <IconButton
              size="md"
              bg={backgroundLightMode}
              border={`1px solid ${backgroundLightMode}`}
              color={textSecondary}
              icon={<FaArrowLeftLong />}
              borderRadius="10.75rem"
              fontSize="0.875rem"
              onClick={closeHandler}
              mr="1rem"
              _hover={{
                bg: primaryAlt,
                color: white,
                border: primaryAlt,
              }}
            />
          </Flex>
          <Heading fontSize="1.25rem" fontWeight="600">
            {t(`module.${selectedSubscription?.name}`)}{" "}
            {t("module.subscription")}
          </Heading>
        </Flex>

        <IconButton
          position="relative"
          zIndex="100"
          // top="1.5rem"
          // right="1.5rem"
          size="sm"
          bg={backgroundLightMode}
          color={textSecondary}
          onClick={closeModalHandler}
          borderRadius="10rem"
          _hover={{ bg: primaryAlt, color: white }}
        >
          <Icon as={FaXmark} />
        </IconButton>
      </Flex>
      {/* HEADER END */}

      {!loadingCheckout ? (
        <Box w="100%">
          {/* MAIN NEW START */}
          <Flex w="100%" justify="space-between" gap="2rem">
            <Flex w="100%" maxW="420px">
              {/* <SubscriptionInfoNew
            subscription={selectedSubscription}
            isYearly={!monthly}
            setIsYearly={setMonthly}
            closeHandler={closeHandler}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
          /> */}
              <SubscriptionSelectedPlanInfo
                subscription={selectedSubscription}
                isYearly={!monthly}
                setIsYearly={setMonthly}
                closeHandler={closeHandler}
                selectedPlan={selectedPlan}
                setSelectedPlan={setSelectedPlan}
                currentCurrency={currentCurrency}
                setCurrentCurrency={setCurrentCurrency}
              />
              {/* <SubscriptionInfo
            subscription={selectedSubscription}
            isYearly={isYearly}
            setIsYearly={setIsYearly}
          /> */}
            </Flex>
            <Flex w="100%" maxW="600px" direction="column">
              {/* <Box m=" 0 0 2rem">
            <Heading fontSize="1.5rem" fontWeight="600" mb="1rem">
              {t("module.activateSubscription")}
            </Heading>
            <Text fontSize="md" fontWeight="500" color={textSecondary}>
              {t("module.activateSubscriptionText")}
            </Text>
          </Box> */}
              {/* <Box h="100%" maxH="400px" overflow="scroll"> */}
              <Box>
                <BillingInfoNew
                  tenant={tenant}
                  address={address}
                  setAddress={setAddress}
                  companyName={companyName}
                  setCompanyName={setCompanyName}
                  companyCode={companyCode}
                  setCompanyCode={setCompanyCode}
                  isIndividual={isIndividual}
                  setIsIndividual={setIsIndividual}
                  fullName={fullName}
                  setFullName={setFullName}
                  vatCode={vatCode}
                  setVatCode={setVatCode}
                />
              </Box>
            </Flex>
          </Flex>

          {/* MAIN NEW END */}

          {/* BUTTONS START */}
          <Flex
            align="center"
            justify="flex-end"
            gap="2rem"
            position="relative"
            m="2rem 0 1rem"
            // bottom="2rem"
            // right="2rem"
          >
            <Flex direction="column" p="0rem 0 0">
              <Flex
                w="100%"
                align="flex-end"
                justify="center"
                direction="column"
                p="0rem 0"
              >
                <Flex align="center">
                  <Icon
                    as={FaCcStripe}
                    color={secondary}
                    fontSize="1.5rem"
                    mr={2}
                  />
                  <Text
                    color={textPrimaryMode}
                    fontWeight="500"
                    fontSize="0.8rem"
                  >
                    {t("module.securePayment")}
                  </Text>
                </Flex>
                <Text
                  color={textSecondary}
                  fontSize="xs"
                  fontWeight="500"
                  m="0.25rem 0 0"
                  textAlign="left"
                >
                  {t("module.securePaymentText")}
                </Text>
              </Flex>
            </Flex>
            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              bg={buttonRed}
              color={buttonRedText}
              isDisabled={
                isIndividual
                  ? isFullNameValid &&
                    isStreetValid &&
                    isCityValid &&
                    isCountryValid &&
                    isZipValid
                  : isCompanyNameValid &&
                    isCompanyCodeValid &&
                    isStreetValid &&
                    isCityValid &&
                    isCountryValid &&
                    isZipValid
              }
              label={
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  textAlign="center"
                >
                  {isIndividual ? (
                    <Stack gap={0}>
                      {!isFullNameValid && (
                        <Text fontSize="xs">
                          {t("formError.fullNameRequired")}
                        </Text>
                      )}
                    </Stack>
                  ) : (
                    <Stack gap={0}>
                      {!isCompanyNameValid && (
                        <Text fontSize="xs">
                          {t("formError.companyNameRequired")}
                        </Text>
                      )}
                      {!isCompanyCodeValid && (
                        <Text fontSize="xs">
                          {t("formError.companyCodeRequired")}
                        </Text>
                      )}
                    </Stack>
                  )}

                  <Stack gap={0}>
                    {!isStreetValid && (
                      <Text fontSize="xs">{t("formError.streetRequired")}</Text>
                    )}
                    {!isCityValid && (
                      <Text fontSize="xs">{t("formError.cityRequired")}</Text>
                    )}
                    {!isCountryValid && (
                      <Text fontSize="xs">
                        {t("formError.countryRequired")}
                      </Text>
                    )}
                    {!isZipValid && (
                      <Text fontSize="xs">{t("formError.zipRequired")}</Text>
                    )}
                  </Stack>
                </Flex>
              }
              placement="top"
            >
              <Button
                size="lg"
                bg={primaryAlt}
                color={white}
                borderRadius="10rem"
                fontSize="1rem"
                fontWeight="500"
                p="0.5rem 1.5rem"
                _hover={{
                  bg: textPrimaryMode,
                }}
                onClick={handleCheckout}
                isLoading={loadingCheckout}
                isDisabled={
                  isIndividual
                    ? !isFullNameValid ||
                      !isStreetValid ||
                      !isCityValid ||
                      !isCountryValid ||
                      !isZipValid
                    : !isCompanyNameValid ||
                      !isCompanyCodeValid ||
                      !isStreetValid ||
                      !isCityValid ||
                      !isCountryValid ||
                      !isZipValid
                }
              >
                {t("module.buyPremiumButton")}
              </Button>
            </Tooltip>
          </Flex>
        </Box>
      ) : (
        <Flex
          w="100%"
          h="100%"
          minH="600px"
          align="center"
          justify="center"
          p="2rem 0"
          direction="column"
        >
          <Spinner size="xl" color={primary} />
          {/* <Text fontSize="md" fontWeight="500" color={textSecondary} mt="1rem">
            {t("module.loadingCheckout")}
          </Text> */}
        </Flex>
      )}
    </>
  );
};

export default CheckoutModalStripe;
